import { render, staticRenderFns } from "./Gana.vue?vue&type=template&id=ea448312"
import script from "./Gana.vue?vue&type=script&lang=js"
export * from "./Gana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports